import React from 'react';
import {Card, CardActions, Button} from '@mui/material';
import ContentCutIcon from '@mui/icons-material/ContentCut';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';

const AgenticEditCard = ({x, y, onCut, onCopy, onPaste}) => {
    const CARD_WIDTH = 180;
    const CARD_HEIGHT = 35;

    const cardStyle = {
        cursor: 'pointer',
        position: 'absolute',
        left: x - CARD_WIDTH / 2,
        top: y - CARD_HEIGHT - 15,
        width: CARD_WIDTH,
        backgroundColor: '#222',
        borderRadius: '16px',
        boxShadow: '0px 5px 15px rgba(0,0,0,0.3)',
        overflow: 'hidden',
        zIndex: 1000,
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        padding: '0 5px',
        boxSizing: 'border-box',
    };

    const btnStyle = {
        height: '25px',
        minWidth: '50px',
        padding: '0px 6px',
        fontSize: '0.75rem',
        margin: '0 2px',
        color: 'white'
    };

    return (
        <Card elevation={5} style={cardStyle}>
            <CardActions>
                <Button variant="text" startIcon={<ContentCutIcon/>} onClick={onCut} style={btnStyle}>Cut</Button>
                <Button variant="text" startIcon={<ContentCopyIcon/>} onClick={onCopy} style={btnStyle}>Copy</Button>
                <Button variant="text" startIcon={<ContentPasteIcon/>} onClick={onPaste} style={btnStyle}>Paste</Button>
            </CardActions>
        </Card>
    );
};

export default AgenticEditCard;